import script from "./CreateReferralCodeForAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateReferralCodeForAccount.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__